// =====================================================
// 📁 components/QuotationViewInfo.tsx
// =====================================================

import React from 'react';

interface Props {
  quotation: any;
}

const QuotationViewInfo: React.FC<Props> = ({ quotation }) => {
  const isCredit = quotation.paymentConditionCode === 'CREDITO';

  const creditTerm =
    quotation.creditDays != null
      ? `${quotation.creditDays} día(s)`
      : quotation.creditMonths != null
        ? `${quotation.creditMonths} mes(es)`
        : quotation.creditYears != null
          ? `${quotation.creditYears} año(s)`
          : quotation.termName || '—';

  return (
    <div
      className="
                grid grid-cols-1 gap-4
                lg:grid-cols-3
            "
    >
      {/* Cliente */}
      <div
        className="
                    rounded-sm border border-stroke
                    bg-white shadow-default
                    dark:border-strokedark
                    dark:bg-boxdark
                "
      >
        <div
          className="
                        border-b border-stroke
                        px-5 py-3
                        dark:border-strokedark
                    "
        >
          <h3
            className="
                            text-base font-semibold
                            text-black dark:text-white
                        "
          >
            Cliente
          </h3>
        </div>

        <div className="p-5">
          <p
            className="
                            text-base font-medium
                            text-black dark:text-white
                        "
          >
            {quotation.customerName}
          </p>
        </div>
      </div>

      {/* Vendedor */}
      <div
        className="
                    rounded-sm border border-stroke
                    bg-white shadow-default
                    dark:border-strokedark
                    dark:bg-boxdark
                "
      >
        <div
          className="
                        border-b border-stroke
                        px-5 py-3
                        dark:border-strokedark
                    "
        >
          <h3
            className="
                            text-base font-semibold
                            text-black dark:text-white
                        "
          >
            Vendedor
          </h3>
        </div>

        <div className="p-5">
          <p
            className="
                            text-base font-medium
                            text-black dark:text-white
                        "
          >
            {quotation.sellerName}
          </p>
        </div>
      </div>

      {/* Sucursal */}
      <div
        className="
                    rounded-sm border border-stroke
                    bg-white shadow-default
                    dark:border-strokedark
                    dark:bg-boxdark
                "
      >
        <div
          className="
                        border-b border-stroke
                        px-5 py-3
                        dark:border-strokedark
                    "
        >
          <h3
            className="
                            text-base font-semibold
                            text-black dark:text-white
                        "
          >
            Sucursal
          </h3>
        </div>

        <div className="p-5">
          <p
            className="
                            text-base font-medium
                            text-black dark:text-white
                        "
          >
            {quotation.branchName}
          </p>
        </div>
      </div>

      {/* Forma de pago */}
      <div
        className="
                    rounded-sm border border-stroke
                    bg-white shadow-default
                    dark:border-strokedark
                    dark:bg-boxdark
                "
      >
        <div
          className="
                        border-b border-stroke
                        px-5 py-3
                        dark:border-strokedark
                    "
        >
          <h3
            className="
                            text-base font-semibold
                            text-black dark:text-white
                        "
          >
            Forma de pago
          </h3>
        </div>

        <div className="p-5">
          <p
            className="
                            text-base font-medium
                            text-black dark:text-white
                        "
          >
            {quotation.paymentConditionName || 'Contado'}
          </p>

          {isCredit && (
            <p className="mt-1 text-sm text-body dark:text-bodydark">
              Plazo: {creditTerm}
              {quotation.creditDueDate ? ` · vence ${quotation.creditDueDate}` : ''}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuotationViewInfo;
